import React from "react";
import {StyledBoxColumn} from "./StyledComponents";
import {
  BaseApp,
  DIALOG_FLAG_DISABLE_BACKDROP_CLICK,
  DIALOG_FLAG_SHOW_CLOSE,
  DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN
} from "./BaseApp";
import {
  FormGenMultiStepConfig,
  FormGenMultiStepFragment,
  FormGenMultiStepFragmentMode
} from "./FormGenMultiStepFragment";
import {FormGenContainerMode} from "./FormGenContainer";

export class FormGenMultiStepHelper {

  static showDialog<T>(object: T, config: FormGenMultiStepConfig, fullscreen?: boolean, opts?: {draft?: boolean, containerMode?: FormGenContainerMode}): string {
    return BaseApp.CONTEXT.showDialog({flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK | (fullscreen ? DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN : 0)}, props =>
      <StyledBoxColumn
        style={{width: fullscreen ? "100dvw" : "92dvw", height: fullscreen ? "100dvh" : "92dvh", overflowY: "hidden"}}>
        <FormGenMultiStepFragment
          draft={Boolean(opts?.draft)}
          containerMode={opts?.containerMode}
          hideDialog={true}
          object={object}
          config={config}/>
      </StyledBoxColumn>);
  }
}